export function copyTextToClipboard(text, callback) {
    navigator.clipboard.writeText(text).then(function () {
        if(callback)callback();
    }, function (err) {
        // console.error('Async: Could not copy text: ', err);
    });
}